// CAPABILITY: pick black/white text for a given background hex (matches the
// StageNavBar contrast logic so the chat header reads correctly on any brand color).
export function getReadableTextColor(hex = "#111827") {
  const n = String(hex).replace("#", "");
  if (n.length !== 6) return "#ffffff";
  const r = parseInt(n.slice(0, 2), 16);
  const g = parseInt(n.slice(2, 4), 16);
  const b = parseInt(n.slice(4, 6), 16);
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return luminance > 0.62 ? "#111827" : "#ffffff";
}

export default getReadableTextColor;
